import Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-log';
import 'prismjs/components/prism-python';
import 'prismjs/themes/prism.css';

export const highlightJson = (data: any): string => {
  try {
    const jsonStr = JSON.stringify(data, null, 2); // pretty print with 2-space indentation
    return Prism.highlight(jsonStr, Prism.languages.json, 'json');
  } catch (error) {
    console.error('Failed to highlight JSON:', error);
    return '';
  }
};

export const highlightPython = (data: string): string => {
  try {
    console.log('Highlighting Python code:', data);
    const python = Prism.highlight(data, Prism.languages.python, 'python');
    console.log('Highlighted Python code:', python);
    return python;
  } catch (error) {
    console.error('Failed to highlight PYTHON:', error);
    return '';
  }
};

export const highlightLog = (data: string): string => {
  try {
    console.log('Highlighting LOG code:', data);
    const log = Prism.highlight(data, Prism.languages.log, 'log');
    console.log('Highlighted LOG code:', log);
    return log;
  } catch (error) {
    console.error('Failed to highlight LOG:', error);
    return '';
  }
};

export const highlightShell = (data: string): string => {
  try {
    return Prism.highlight(data, Prism.languages.bash, 'bash');
  } catch (error) {
    console.error('Failed to highlight SHELL:', error);
    return '';
  }
};
